<template>
	<transition
			appear
			:appear-active-class="$_inpStpLyt_stylePageLayoutAnimation()">
		<v-row	id="_inpStpLyt_top" class="customVRow" no-gutters>
			<!-- outer stepper for input steps  -->
			<v-col>
				<v-stepper
						v-model="outerStepNumber_"
						class="stepper_"
						:dark="$_inpStpLyt_styleOuterStepperDark"
						:light="$_inpStpLyt_styleOuterStepperLight"
						:vertical="$_inpStpLyt_stateAppIsMobileScreen">
					<!-- outer stepper header ( only for web ) -->
					<template v-if="!$_inpStpLyt_stateAppIsMobileScreen">
						<v-row no-gutters>
							<v-col>
								<v-sheet
										class="customVSheet px-3 ma-3"
										:color="$_inpStpLyt_styleOuterStepperSheetColor"
										:dark="$_inpStpLyt_styleOuterStepperSheetDark"
										:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
										:light="$_inpStpLyt_styleOuterStepperSheetLight">
									<v-stepper-header class="stepperHeader_">
										<v-row>
											<template v-for="(stepVals, stepKey) in outerSteps_">
												<v-col :key="stepKey">
													<v-card class="customVCard"
															:color="$_inpStpLyt_styleOuterStepperHeaderCardColor"
															:dark="$_inpStpLyt_styleOuterStepperHeaderCardDark"
															:elevation="$_inpStpLyt_styleOuterStepperHeaderCardElevation"
															:flat="$_inpStpLyt_styleOuterStepperHeaderCardFlat"
															:hover="$_inpStpLyt_styleOuterStepperHeaderCardHover"
															:light="$_inpStpLyt_styleOuterStepperHeaderCardLight"
															:outlined="$_inpStpLyt_styleOuterStepperHeaderCardOutlined"
															:raised="$_inpStpLyt_styleOuterStepperHeaderCardRaised"
															:tile="$_inpStpLyt_styleOuterStepperHeaderCardTile">
														<v-stepper-step 
																class="stepperStep_"
																:color="$_inpStpLyt_styleOuterStepperStepColor"
																:complete="outerCompleted_[stepKey]"
																:step="stepVals.stepNumber">
															<span v-html="stepVals.title" />
														</v-stepper-step>
													</v-card>
												</v-col>
											</template>
										</v-row>
									</v-stepper-header>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
					<!-- outer stepper body (input mode) -->
					<v-stepper-items class="stepperItem_">
						<!-- outer stepper body - step head (only for mobile) -->
						<template v-if="$_inpStpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpStpLyt_styleOuterStepperSheetColor"
											:dark="$_inpStpLyt_styleOuterStepperSheetDark"
											:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
											:light="$_inpStpLyt_styleOuterStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpStpLyt_styleOuterStepperHeaderCardColor"
														:dark="$_inpStpLyt_styleOuterStepperHeaderCardDark"
														:elevation="$_inpStpLyt_styleOuterStepperHeaderCardElevation"
														:flat="$_inpStpLyt_styleOuterStepperHeaderCardFlat"
														:hover="$_inpStpLyt_styleOuterStepperHeaderCardHover"
														:light="$_inpStpLyt_styleOuterStepperHeaderCardLight"
														:outlined="$_inpStpLyt_styleOuterStepperHeaderCardOutlined"
														:raised="$_inpStpLyt_styleOuterStepperHeaderCardRaised"
														:tile="$_inpStpLyt_styleOuterStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															step="1"
															:color="$_inpStpLyt_styleOuterStepperStepColor"
															:complete="outerCompleted_.input">
														<span v-html="outerSteps_.input.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- outer stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								step="1">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet ma-3"
											:color="$_inpStpLyt_styleOuterStepperSheetColor"
											:dark="$_inpStpLyt_styleOuterStepperSheetDark"
											:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
											:light="$_inpStpLyt_styleOuterStepperSheetLight">
										<!-- inner stepper for content steps -->
										<v-stepper
												v-model="innerStepNumber_"
												class="stepper_"
												:dark="$_inpStpLyt_styleInnerStepperDark"
												:light="$_inpStpLyt_styleInnerStepperLight"
												:vertical="$_inpStpLyt_stateAppIsMobileScreen">
											<!-- inner stepper header ( only for web ) -->
											<template v-if="!$_inpStpLyt_stateAppIsMobileScreen">
												<v-row no-gutters>
													<v-col>
														<v-sheet
																class="customVSheet px-3 ma-3"
																:color="$_inpStpLyt_styleInnerStepperSheetColor"
																:dark="$_inpStpLyt_styleInnerStepperSheetDark"
																:elevation="$_inpStpLyt_styleInnerStepperSheetElevation"
																:light="$_inpStpLyt_styleInnerStepperSheetLight">
															<v-stepper-header class="stepperHeader_">
																<v-row>
																	<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
																		<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
																			<v-col :key="contentKey">
																				<v-card class="customVCard"
																						:color="$_inpStpLyt_styleInnerStepperHeaderCardColor"
																						:dark="$_inpStpLyt_styleInnerStepperHeaderCardDark"
																						:elevation="$_inpStpLyt_styleInnerStepperHeaderCardElevation"
																						:flat="$_inpStpLyt_styleInnerStepperHeaderCardFlat"
																						:hover="$_inpStpLyt_styleInnerStepperHeaderCardHover"
																						:light="$_inpStpLyt_styleInnerStepperHeaderCardLight"
																						:outlined="$_inpStpLyt_styleInnerStepperHeaderCardOutlined"
																						:raised="$_inpStpLyt_styleInnerStepperHeaderCardRaised"
																						:tile="$_inpStpLyt_styleInnerStepperHeaderCardTile">
																					<v-stepper-step 
																							class="stepperStep_"
																							:color="$_inpStpLyt_styleInnerStepperStepColor"
																							:complete="innerCompleted_[contentVals.stepNumber]"
																							:step="contentVals.stepNumber">
																						<span v-html="$_inpStpLyt_langContentTitle(contentVals)" />
																					</v-stepper-step>
																				</v-card>
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</v-stepper-header>
														</v-sheet>
													</v-col>
												</v-row>
											</template>
											<!-- inner stepper body -->
											<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
												<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
													<v-stepper-items
															:key="contentKey"
															class="stepperItem_">
														<!-- inner stepper body - step head (only for mobile) -->
														<template v-if="$_inpStpLyt_stateAppIsMobileScreen">
															<v-row>
																<v-col>
																	<v-card class="customVCard"
																			:color="$_inpStpLyt_styleInnerStepperHeaderCardColor"
																			:dark="$_inpStpLyt_styleInnerStepperHeaderCardDark"
																			:elevation="$_inpStpLyt_styleInnerStepperHeaderCardElevation"
																			:flat="$_inpStpLyt_styleInnerStepperHeaderCardFlat"
																			:hover="$_inpStpLyt_styleInnerStepperHeaderCardHover"
																			:light="$_inpStpLyt_styleInnerStepperHeaderCardLight"
																			:outlined="$_inpStpLyt_styleInnerStepperHeaderCardOutlined"
																			:raised="$_inpStpLyt_styleInnerStepperHeaderCardRaised"
																			:tile="$_inpStpLyt_styleInnerStepperHeaderCardTile">
																		<v-stepper-step
																				class="stepperStep_"
																				:color="$_inpStpLyt_styleInnerStepperStepColor"
																				:complete="innerCompleted_[contentVals.stepNumber]"
																				:step="contentVals.stepNumber">
																			<span v-html="$_inpStpLyt_langContentTitle(contentVals)" />
																		</v-stepper-step>
																	</v-card>
																</v-col>
															</v-row>
														</template>
														<!-- inner stepper body - step body -->
														<v-stepper-content
																class="stepperContent_"
																:step="contentVals.stepNumber">
															<validation-observer :ref="contentKey" v-slot="[contentKey]">
																<v-form>
																	<template v-if="!isEmpty(errorMessage_)">
																		<v-row>
																			<v-col>
																				<v-card class="customVCard"
																						color="transparent"
																						flat>
																					<v-card-text>
																						<span v-html="errorMessage_" />
																					</v-card-text>
																				</v-card>
																			</v-col>
																		</v-row>
																	</template>
																	<v-row no-gutters>
																		<v-col>
																			<v-sheet
																					class="customVSheet px-3 ma-3"
																					:color="$_inpStpLyt_styleInnerStepperSheetColor"
																					:dark="$_inpStpLyt_styleInnerStepperSheetDark"
																					:elevation="$_inpStpLyt_styleInnerStepperSheetElevation"
																					:light="$_inpStpLyt_styleInnerStepperSheetLight">
																				<v-row>
																					<template v-if="contentVals.image">
																						<v-col xs="12" md="6">
																							<v-img	class="customVImg"
																									cover 
																									:src="$_inpStpLyt_styleContentImageUrl(contentVals)" />
																						</v-col>
																					</template>
																					<template v-if="contentVals.title && isObject(contentVals.actionButtons)">
																						<v-col xs="12" md="6">
																							<v-row no-gutters>
																								<v-col>
																									<template v-if="contentVals.title">
																										<v-card-text>
																											<v-row dense>
																												<v-col>
																													<span v-html="$_inpStpLyt_langContentText(contentVals)" />
																												</v-col>
																											</v-row>
																										</v-card-text>
																									</template>
																									<template v-if="isObject(contentVals.actionButtons)">
																										<v-card-actions>
																											<v-row dense>
																												<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																													<template v-if="!$_inpStpLyt_isPreSetButton(actionButtonKey)">
																														<v-col :key="actionButtonKey" class="px-2" cols="auto">
																															<v-btn	class="customVBtn"
																																	:block="$_inpStpLyt_styleActionButtonBlock"
																																	:color="$_inpStpLyt_styleActionButtonColor"
																																	:dark="$_inpStpLyt_styleActionButtonDark"
																																	:depressed="$_inpStpLyt_styleActionButtonDepressed"
																																	:elevation="$_inpStpLyt_styleActionButtonElevation"
																																	:large="$_inpStpLyt_styleActionButtonLarge"
																																	:light="$_inpStpLyt_styleActionButtonLight"
																																	:outlined="$_inpStpLyt_styleActionButtonOutlined"
																																	:rounded="$_inpStpLyt_styleActionButtonRounded"
																																	:small="$_inpStpLyt_styleActionButtonSmall"
																																	:text="$_inpStpLyt_styleActionButtonFlat"
																																	@click="openLink(actionButtonVals.link)"
																																	v-text="$_inpStpLyt_langActionButtonTitle(actionButtonVals)" />
																														</v-col>
																													</template>
																												</template>
																											</v-row>
																										</v-card-actions>
																									</template>
																								</v-col>
																							</v-row>
																						</v-col>
																					</template>
																				</v-row>
																				<template v-for="(questionVals, questionKey) in contentVals.questions">
																					<template v-if="questionVals.title">
																						<v-row :key="`title-${questionKey}`">
																							<v-col>
																								<v-card class="customVCard"
																										:color="$_inpStpLyt_styleInnerStepperBodyCardColor"
																										:dark="$_inpStpLyt_styleInnerStepperBodyCardDark"
																										:elevation="$_inpStpLyt_styleInnerStepperBodyCardElevation"
																										:flat="$_inpStpLyt_styleInnerStepperBodyCardFlat"
																										:hover="$_inpStpLyt_styleInnerStepperBodyCardHover"
																										:light="$_inpStpLyt_styleInnerStepperBodyCardLight"
																										:outlined="$_inpStpLyt_styleInnerStepperBodyCardOutlined"
																										:raised="$_inpStpLyt_styleInnerStepperBodyCardRaised"
																										:tile="$_inpStpLyt_styleInnerStepperBodyCardTile">
																									<v-card-text>
																										<v-row dense>
																											<v-col>
																												<span v-html="$_inpStpLyt_langQuestionTitle(questionVals)" />
																											</v-col>
																										</v-row>
																									</v-card-text>
																								</v-card>
																							</v-col>
																						</v-row>
																					</template>
																					<v-row :key="`content-${questionKey}`">
																						<v-col>
																							<v-card class="customVCard"
																									:color="$_inpStpLyt_styleInnerStepperBodyCardColor"
																									:dark="$_inpStpLyt_styleInnerStepperBodyCardDark"
																									:elevation="$_inpStpLyt_styleInnerStepperBodyCardElevation"
																									:flat="$_inpStpLyt_styleInnerStepperBodyCardFlat"
																									:hover="$_inpStpLyt_styleInnerStepperBodyCardHover"
																									:light="$_inpStpLyt_styleInnerStepperBodyCardLight"
																									:outlined="$_inpStpLyt_styleInnerStepperBodyCardOutlined"
																									:raised="$_inpStpLyt_styleInnerStepperBodyCardRaised"
																									:tile="$_inpStpLyt_styleInnerStepperBodyCardTile">
																								<template v-if="questionVals.image">
																									<v-row>
																										<v-col>
																											<v-img	class="customVImg cardImage_"
																													:src="$_inpStpLyt_styleContentQuestionImageUrl(questionVals)" />
																										</v-col>
																									</v-row>
																								</template>
																								<template v-if="questionVals.text">
																									<v-card-title>
																										<v-row dense>
																											<v-col>
																												<span v-html="$_inpStpLyt_langQuestionText(questionVals)" />
																											</v-col>
																										</v-row>
																									</v-card-title>
																								</template>
																								<v-card-text>
																									<!-- check box -->
																									<template v-if="questionVals.type.checkbox">
																										<v-row>
																											<v-col>
																												<input-checkbox
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- combobox -->
																									<template v-else-if="questionVals.type.combobox">
																										<v-row>
																											<v-col>
																												<input-combobox
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- combobox multiple -->
																									<template v-else-if="questionVals.type.comboboxMultiple">
																										<v-row>
																											<v-col>
																												<input-combobox-multiple
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- radio button -->
																									<template v-else-if="questionVals.type.radioButton">
																										<v-row>
																											<v-col>
																												<input-radio-button
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- select -->
																									<template v-else-if="questionVals.type.select">
																										<v-row>
																											<v-col>
																												<input-select
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- select multiple -->
																									<template v-else-if="questionVals.type.selectMultiple">
																										<v-row>
																											<v-col>
																												<input-select-multiple
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- slider -->
																									<template v-else-if="questionVals.type.slider">
																										<v-row>
																											<v-col>
																												<input-slider
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- switch -->
																									<template v-else-if="questionVals.type.switch">
																										<v-row>
																											<v-col>
																												<input-switch
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- textarea -->
																									<template v-else-if="questionVals.type.textarea">
																										<v-row>
																											<v-col>
																												<input-textarea
																														:contentKey="questionKey"
																														:contents="contents"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																									<!-- text field -->
																									<template v-else-if="questionVals.type.textField">
																										<v-row>
																											<v-col>
																												<input-text-field
																														:contentKey="questionKey"
																														:contents="contentVals.questions"
																														:inits="inits" />
																											</v-col>
																										</v-row>
																									</template>
																								</v-card-text>
																								<!-- action buttons --> 
																								<template v-if="!isEmpty(questionVals.actionButtons)">
																									<v-card-actions>
																										<v-row dense>
																											<template v-for="(questionActionButtonVals, questionActionButtonKey) in sortObject(questionVals.actionButtons, 'order')">
																												<v-col	:key="questionActionButtonKey"
																														cols="auto">
																													<v-btn	class="customVBtn"
																															:block="$_inpStpLyt_styleQuestionActionButtonBlock"
																															:color="$_inpStpLyt_styleQuestionActionButtonColor"
																															:dark="$_inpStpLyt_styleQuestionActionButtonDark"
																															:depressed="$_inpStpLyt_styleQuestionActionButtonDepressed"
																															:elevation="$_inpStpLyt_styleQuestionActionButtonElevation"
																															:large="$_inpStpLyt_styleQuestionActionButtonLarge"
																															:light="$_inpStpLyt_styleQuestionActionButtonLight"
																															:outlined="$_inpStpLyt_styleQuestionActionButtonOutlined"
																															:rounded="$_inpStpLyt_styleQuestionActionButtonRounded"
																															:small="$_inpStpLyt_styleQuestionActionButtonSmall"
																															:text="$_inpStpLyt_styleQuestionActionButtonFlat"
																															@click="openLink(questionActionButtonVals.link)"
																															v-text="$_inpStpLyt_langActionButtonTitle(questionActionButtonVals)" />
																												</v-col>
																											</template>
																										</v-row>
																									</v-card-actions>
																								</template>
																							</v-card>
																						</v-col>
																					</v-row>
																				</template>
																			</v-sheet>
																		</v-col>
																	</v-row>
																	<v-row	align="center"
																			justify="center">
																		<!-- back button -->
																		<template v-if="contentVals.previousStepNumber">
																			<v-col cols="auto">
																				<v-btn	class="customVBtn"
																						:block="$_inpStpLyt_styleInnerStepperActionButtonBlock"
																						:color="$_inpStpLyt_styleInnerStepperActionButtonColor('backStepInner')"
																						:dark="$_inpStpLyt_styleInnerStepperActionButtonDark"
																						:depressed="$_inpStpLyt_styleInnerStepperActionButtonDepressed"
																						:elevation="$_inpStpLyt_styleInnerStepperActionButtonElevation"
																						:large="$_inpStpLyt_styleInnerStepperActionButtonLarge"
																						:light="$_inpStpLyt_styleInnerStepperActionButtonLight"
																						:outlined="$_inpStpLyt_styleInnerStepperActionButtonOutlined"
																						:rounded="$_inpStpLyt_styleInnerStepperActionButtonRounded"
																						:small="$_inpStpLyt_styleInnerStepperActionButtonSmall"
																						:text="$_inpStpLyt_styleInnerStepperActionButtonFlat"
																						@click="$_inpStpLyt_click(contentVals, contentKey, 'back')"
																						v-text="$_inpStpLyt_langBackStepButton" />
																			</v-col>
																		</template>
																		<!-- next button -->
																		<template v-if="contentVals.nextStepNumber">
																			<v-col cols="auto">
																				<v-btn	class="customVBtn"
																						:block="$_inpStpLyt_styleInnerStepperActionButtonBlock"
																						:color="$_inpStpLyt_styleInnerStepperActionButtonColor('nextStepInner')"
																						:dark="[contentKey].passed ? $_inpStpLyt_stateAppIsDarkTheme : $_inpStpLyt_styleInnerStepperActionButtonDark"
																						:depressed="$_inpStpLyt_styleInnerStepperActionButtonDepressed"
																						:elevation="$_inpStpLyt_styleInnerStepperActionButtonElevation"
																						:large="$_inpStpLyt_styleInnerStepperActionButtonLarge"
																						:light="$_inpStpLyt_styleInnerStepperActionButtonLight"
																						:outlined="$_inpStpLyt_styleInnerStepperActionButtonOutlined"
																						:rounded="$_inpStpLyt_styleInnerStepperActionButtonRounded"
																						:small="$_inpStpLyt_styleInnerStepperActionButtonSmall"
																						:text="$_inpStpLyt_styleInnerStepperActionButtonFlat"

																						:disabled="[contentKey].passed"

																						@click="$_inpStpLyt_click(contentVals, contentKey, 'next')"
																						v-text="$_inpStpLyt_langNextStepButton" />
																			</v-col>
																		</template>
																		<!-- submit button -->
																		<template v-if="contentVals.isLastStep">
																			<v-col cols="auto">
																				<v-btn	class="customVBtn"
																						:block="$_inpStpLyt_styleInnerStepperActionButtonBlock"
																						:color="$_inpStpLyt_styleInnerStepperActionButtonColor('submit')"
																						:dark="[contentKey].passed ? $_inpStpLyt_stateAppIsDarkTheme : $_inpStpLyt_styleInnerStepperActionButtonDark"
																						:depressed="$_inpStpLyt_styleInnerStepperActionButtonDepressed"
																						:elevation="$_inpStpLyt_styleInnerStepperActionButtonElevation"
																						:large="$_inpStpLyt_styleInnerStepperActionButtonLarge"
																						:light="$_inpStpLyt_styleInnerStepperActionButtonLight"
																						:outlined="$_inpStpLyt_styleInnerStepperActionButtonOutlined"
																						:rounded="$_inpStpLyt_styleInnerStepperActionButtonRounded"
																						:small="$_inpStpLyt_styleInnerStepperActionButtonSmall"
																						:text="$_inpStpLyt_styleInnerStepperActionButtonFlat"

																						:disabled="[contentKey].passed"

																						@click="$_inpStpLyt_click(contentVals, contentKey, 'submit')"
																						v-text="$_inpStpLyt_langSubmitButton" />
																			</v-col>
																		</template>
																	</v-row>
																</v-form>
															</validation-observer>
														</v-stepper-content>
													</v-stepper-items>
												</template>
											</template>
										</v-stepper>
									</v-sheet>
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
					<!-- outer stepper body (submit mode) -->
					<v-stepper-items class="stepperItem_">
						<!-- outer stepper body - step head (only for mobile) -->
						<template v-if="$_inpStpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpStpLyt_styleOuterStepperSheetColor"
											:dark="$_inpStpLyt_styleOuterStepperSheetDark"
											:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
											:light="$_inpStpLyt_styleOuterStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpStpLyt_styleOuterStepperHeaderCardColor"
														:dark="$_inpStpLyt_styleOuterStepperHeaderCardDark"
														:elevation="$_inpStpLyt_styleOuterStepperHeaderCardElevation"
														:flat="$_inpStpLyt_styleOuterStepperHeaderCardFlat"
														:hover="$_inpStpLyt_styleOuterStepperHeaderCardHover"
														:light="$_inpStpLyt_styleOuterStepperHeaderCardLight"
														:outlined="$_inpStpLyt_styleOuterStepperHeaderCardOutlined"
														:raised="$_inpStpLyt_styleOuterStepperHeaderCardRaised"
														:tile="$_inpStpLyt_styleOuterStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															step="2"
															:color="$_inpStpLyt_styleOuterStepperStepColor"
															:complete="outerCompleted_.submit">
														<span v-html="outerSteps_.submit.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- outer stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								step="2">
							<v-sheet
									class="customVSheet px-3 ma-3"
									:color="$_inpStpLyt_styleOuterStepperSheetColor"
									:dark="$_inpStpLyt_styleOuterStepperSheetDark"
									:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
									:light="$_inpStpLyt_styleOuterStepperSheetLight">
								<template v-for="(answerVals, answerKey) in $_inpStpLyt_stateInputData">
									<template v-if="answerVals.question.title">
										<v-row :key="`title-${answerKey}`">
											<v-col>
												<v-card class="customVCard"
														:color="$_inpStpLyt_styleOuterStepperBodyCardColor"
														:dark="$_inpStpLyt_styleOuterStepperBodyCardDark"
														:elevation="$_inpStpLyt_styleOuterStepperBodyCardElevation"
														:flat="$_inpStpLyt_styleOuterStepperBodyCardFlat"
														:hover="$_inpStpLyt_styleOuterStepperBodyCardHover"
														:light="$_inpStpLyt_styleOuterStepperBodyCardLight"
														:outlined="$_inpStpLyt_styleOuterStepperBodyCardOutlined"
														:raised="$_inpStpLyt_styleOuterStepperBodyCardRaised"
														:tile="$_inpStpLyt_styleOuterStepperBodyCardTile">
													<v-card-text>
														<v-row dense>
															<v-col>
																<span v-html="answerVals.question.title" />
															</v-col>
														</v-row>
													</v-card-text>
												</v-card>
											</v-col>
										</v-row>
									</template>
									<v-row :key="`content-${answerKey}`">
										<v-col>
											<v-card class="customVCard"
													:color="$_inpStpLyt_styleOuterStepperBodyCardColor"
													:dark="$_inpStpLyt_styleOuterStepperBodyCardDark"
													:elevation="$_inpStpLyt_styleOuterStepperBodyCardElevation"
													:flat="$_inpStpLyt_styleOuterStepperBodyCardFlat"
													:hover="$_inpStpLyt_styleOuterStepperBodyCardHover"
													:light="$_inpStpLyt_styleOuterStepperBodyCardLight"
													:outlined="$_inpStpLyt_styleOuterStepperBodyCardOutlined"
													:raised="$_inpStpLyt_styleOuterStepperBodyCardRaised"
													:tile="$_inpStpLyt_styleOuterStepperBodyCardTile">
												<template v-if="!isFalse(answerVals.question.text)">
													<v-card-title>
														<v-row dense>
															<v-col>
																<span 	class="subtitle-1 markdown"
																		v-html="marked(answerVals.question.text)" />
															</v-col>
														</v-row>
													</v-card-title>
												</template>
												<v-card-text>
													<template v-if="answerVals.type == 'checkbox' || answerVals.type == 'switch'">
														<v-row dense>
															<template v-for="(vals, key) in answerVals.answer">
																<template v-if="vals.value">
																	<v-col :key="key">
																		<span	class="subtitle-1"
																				v-html="vals.text" />
																	</v-col>
																</template>
															</template>
														</v-row>
													</template>
													<template v-else-if="answerVals.type == 'combobox'">
														<v-row dense>
															<v-col>
																<template v-if="isObject(answerVals.answer)">
																	<span	class="subtitle-1"
																			v-html="answerVals.answer.text" />
																</template>
																<template v-else>
																	<span	class="subtitle-1"
																			v-html="answerVals.answer" />
																</template>
															</v-col>
														</v-row>
													</template>
													<template v-else-if="answerVals.type == 'comboboxMultiple'">
														<v-row dense>
															<template v-for="(vals, key) in answerVals.answer">
																<template v-if="isObject(vals)">
																	<v-col :key="key">
																		<span	class="subtitle-1"
																				v-html="vals.text" />
																	</v-col>
																</template>
																<template v-else>
																	<v-col :key="key">
																		<span	class="subtitle-1"
																				v-html="vals" />
																	</v-col>
																</template>
															</template>
														</v-row>
													</template>
													<template v-else-if="answerVals.type == 'radioButton' || answerVals.type == 'select'">
														<v-row dense>
															<v-col>
																<span	class="subtitle-1"
																		v-html="answerVals.answer.text" />
															</v-col>
														</v-row>
													</template>
													<template v-else-if="answerVals.type == 'selectMultiple'">
														<v-row dense>
															<template v-for="(vals, key) in answerVals.answer">
																<v-col :key="key">
																	<span	class="subtitle-1"
																			v-html="vals.text" />
																</v-col>
															</template>
														</v-row>
													</template>
													<template v-else>
														<v-row dense>
															<v-col>
																<span	class="subtitle-1"
																		v-html="answerVals.answer" />
															</v-col>
														</v-row>
													</template>
												</v-card-text>
											</v-card>
										</v-col>
									</v-row>
								</template>
							</v-sheet>
							<v-row	align="center" 
									justify="center">
								<!-- back button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_inpStpLyt_styleOuterStepperActionButtonBlock"
											:color="$_inpStpLyt_styleOuterStepperActionButtonColor('backStepOuter')"
											:dark="$_inpStpLyt_styleOuterStepperActionButtonDark"
											:depressed="$_inpStpLyt_styleOuterStepperActionButtonDepressed"
											:elevation="$_inpStpLyt_styleOuterStepperActionButtonElevation"
											:large="$_inpStpLyt_styleOuterStepperActionButtonLarge"
											:light="$_inpStpLyt_styleOuterStepperActionButtonLight"
											:outlined="$_inpStpLyt_styleOuterStepperActionButtonOutlined"
											:rounded="$_inpStpLyt_styleOuterStepperActionButtonRounded"
											:small="$_inpStpLyt_styleOuterStepperActionButtonSmall"
											:text="$_inpStpLyt_styleOuterStepperActionButtonFlat"
											@click="$_inpStpLyt_back()"
											v-text="$_inpStpLyt_langBackButton" />
								</v-col>
								<!-- confirm button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
									:block="$_inpStpLyt_styleOuterStepperActionButtonBlock"
											:color="$_inpStpLyt_styleOuterStepperActionButtonColor('confirm')"
											:dark="$_inpStpLyt_styleOuterStepperActionButtonDark"
											:depressed="$_inpStpLyt_styleOuterStepperActionButtonDepressed"
											:elevation="$_inpStpLyt_styleOuterStepperActionButtonElevation"
											:large="$_inpStpLyt_styleOuterStepperActionButtonLarge"
											:light="$_inpStpLyt_styleOuterStepperActionButtonLight"
											:outlined="$_inpStpLyt_styleOuterStepperActionButtonOutlined"
											:rounded="$_inpStpLyt_styleOuterStepperActionButtonRounded"
											:small="$_inpStpLyt_styleOuterStepperActionButtonSmall"
											:text="$_inpStpLyt_styleOuterStepperActionButtonFlat"
											@click="$_inpStpLyt_confirm()">
										<template v-if="onProgress_">
											<progress-circular />
										</template>
										<template v-else>
											<span v-text="$_inpStpLyt_langConfirmButton" />
										</template>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
					<!-- outer stepper body (confirm mode) -->
					<v-stepper-items class="stepperItem_">
						<!-- outer stepper body - step head (only for mobile) -->
						<template v-if="$_inpStpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpStpLyt_styleOuterStepperSheetColor"
											:dark="$_inpStpLyt_styleOuterStepperSheetDark"
											:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
											:light="$_inpStpLyt_styleOuterStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpStpLyt_styleOuterStepperHeaderCardColor"
														:dark="$_inpStpLyt_styleOuterStepperHeaderCardDark"
														:elevation="$_inpStpLyt_styleOuterStepperHeaderCardElevation"
														:flat="$_inpStpLyt_styleOuterStepperHeaderCardFlat"
														:hover="$_inpStpLyt_styleOuterStepperHeaderCardHover"
														:light="$_inpStpLyt_styleOuterStepperHeaderCardLight"
														:outlined="$_inpStpLyt_styleOuterStepperHeaderCardOutlined"
														:raised="$_inpStpLyt_styleOuterStepperHeaderCardRaised"
														:tile="$_inpStpLyt_styleOuterStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															step="3"
															:color="$_inpStpLyt_styleOuterStepperStepColor"
															:complete="outerCompleted_.finish">
														<span v-html="outerSteps_.finish.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- outer stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								step="3">
							<v-sheet
									class="customVSheet px-3 ma-3"
									:color="$_inpStpLyt_styleOuterStepperSheetColor"
									:dark="$_inpStpLyt_styleOuterStepperSheetDark"
									:elevation="$_inpStpLyt_styleOuterStepperSheetElevation"
									:light="$_inpStpLyt_styleOuterStepperSheetLight">
								<v-row>
									<v-col>
										<v-card class="customVCard">
											<v-card-text>
												<v-row dense>
													<v-col>
														<span v-html="$_inpStpLyt_langFinishText" />
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-sheet>
							<v-row	align="center"
									justify="center">
								<!-- ok button -->
								<v-col cols="auto">
									<v-btn	:block="$_inpStpLyt_styleOuterStepperActionButtonBlock"
											:color="$_inpStpLyt_styleOuterStepperActionButtonColor('finish')"
											:dark="$_inpStpLyt_styleOuterStepperActionButtonDark"
											:depressed="$_inpStpLyt_styleOuterStepperActionButtonDepressed"
											:elevation="$_inpStpLyt_styleOuterStepperActionButtonElevation"
											:large="$_inpStpLyt_styleOuterStepperActionButtonLarge"
											:light="$_inpStpLyt_styleOuterStepperActionButtonLight"
											:outlined="$_inpStpLyt_styleOuterStepperActionButtonOutlined"
											:rounded="$_inpStpLyt_styleOuterStepperActionButtonRounded"
											:small="$_inpStpLyt_styleOuterStepperActionButtonSmall"
											:text="$_inpStpLyt_styleOuterStepperActionButtonFlat"
											@click="openLink($_inpStpLyt_linkOkButton)"
											v-text="$_inpStpLyt_langOkButton" />
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputWithStepperLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				valid_: true,
				mode_: {
					input: true,
					submit: false,
					finish: false
				},

				errorMessage_: '',

				onProgress_: false,

				// for stepper
				innerStepNumber_: 1,
				innerCompleted_: {},

				// for input
				outerSteps_: {
					input: {
						stepNumber: 1,
						title: 'Input'
					},
					submit: {
						stepNumber: 2,
						title: 'Submit'
					},
					finish: {
						stepNumber: 3,
						title: 'Finish'
					}
				},
				outerStepNumber_: 1,
				outerCompleted_: {}
			}
		},
		computed: {
			// current user
			$_inpStpLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_inpStpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_inpStpLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_inpStpLyt_stateInput() {
				const self_ = this;
				return self_.getInputState()
			},
			$_inpStpLyt_stateInputData() {
				const self_ = this;
				const input_ = self_.$_inpStpLyt_stateInput
				if(self_.isFalse(input_)) { return null }
				return input_.data
			},
			// info
			$_inpStpLyt_infoContactUid() {
				const self_ = this;
				const contact_ = self_.getInitsInfoVal(self_.inits, 'contact')
				if(self_.isFalse(contact_)) { return null }
				return contact_.uid
			},
			// lang
			$_inpStpLyt_langInputTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'inputTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'submitButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langSubmitTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'submitTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langConfirmButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'confirmButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langFinishText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langFinishTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langBackStepButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backStepButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langNextStepButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'nextStepButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpStpLyt_langMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'message')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_inpStpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_inpStpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_inpStpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// (content - question)
			$_inpStpLyt_langQuestionTitle() {
				const self_ = this;
				return questionVals => {
					const title_ = questionVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_inpStpLyt_langQuestionText() {
				const self_ = this;
				return questionVals => {
					const text_ = questionVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			// link
			$_inpStpLyt_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'okButton')
			},
			// style
			$_inpStpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_inpStpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpStpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpStpLyt_styleOuterStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'outerStepper')
			},
			$_inpStpLyt_styleOuterStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_inpStpLyt_styleOuterStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_inpStpLyt_styleOuterStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_inpStpLyt_styleOuterStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_inpStpLyt_styleOuterStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_inpStpLyt_styleOuterStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_inpStpLyt_styleOuterStepperSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'outerStepperSheet')
			},
			$_inpStpLyt_styleOuterStepperSheetColor() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpStpLyt_styleOuterStepperSheetDark() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpStpLyt_styleOuterStepperSheetElevation() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpStpLyt_styleOuterStepperSheetLight() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpStpLyt_styleOuterStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'outerStepperHeaderCard')
			},
			$_inpStpLyt_styleOuterStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_inpStpLyt_styleOuterStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_inpStpLyt_styleOuterStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'outerStepperBodyCard')
			},
			$_inpStpLyt_styleOuterStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpStpLyt_styleOuterStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpStpLyt_styleOuterStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpStpLyt_styleOuterStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_inpStpLyt_styleOuterStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_inpStpLyt_styleOuterStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpStpLyt_styleOuterStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_inpStpLyt_styleOuterStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_inpStpLyt_styleOuterStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleOuterStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_inpStpLyt_styleOuterStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'outerStepperActionButton')
			},
			$_inpStpLyt_styleOuterStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_inpStpLyt_styleOuterStepperActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return key => {
					if(self_.isObject(actionButton_.color)) {
						return	self_.getStylesVal(actionButton_.color[key]) ||
								self_.getStylesVal(actionButton_.color.default)
					} else {
						return self_.getStylesVal(actionButton_.color)
					}
				}
			},
			$_inpStpLyt_styleOuterStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_inpStpLyt_styleOuterStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_inpStpLyt_styleOuterStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_inpStpLyt_styleOuterStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_inpStpLyt_styleOuterStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_inpStpLyt_styleOuterStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_inpStpLyt_styleOuterStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_inpStpLyt_styleOuterStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_inpStpLyt_styleOuterStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleOuterStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_inpStpLyt_styleInnerStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'innerStepper')
			},
			$_inpStpLyt_styleInnerStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_inpStpLyt_styleInnerStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_inpStpLyt_styleInnerStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_inpStpLyt_styleInnerStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_inpStpLyt_styleInnerStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_inpStpLyt_styleInnerStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_inpStpLyt_styleInnerStepperSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'innerStepperSheet')
			},
			$_inpStpLyt_styleInnerStepperSheetColor() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpStpLyt_styleInnerStepperSheetDark() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpStpLyt_styleInnerStepperSheetElevation() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpStpLyt_styleInnerStepperSheetLight() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpStpLyt_styleInnerStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'innerStepperHeaderCard')
			},
			$_inpStpLyt_styleInnerStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_inpStpLyt_styleInnerStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_inpStpLyt_styleInnerStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'innerStepperBodyCard')
			},
			$_inpStpLyt_styleInnerStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpStpLyt_styleInnerStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpStpLyt_styleInnerStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpStpLyt_styleInnerStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_inpStpLyt_styleInnerStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_inpStpLyt_styleInnerStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpStpLyt_styleInnerStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_inpStpLyt_styleInnerStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_inpStpLyt_styleInnerStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_inpStpLyt_styleInnerStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_inpStpLyt_styleInnerStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'innerStepperActionButton')
			},
			$_inpStpLyt_styleInnerStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_inpStpLyt_styleInnerStepperActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return key => {
					if(self_.isObject(actionButton_.color)) {
						return	self_.getStylesVal(actionButton_.color[key]) ||
								self_.getStylesVal(actionButton_.color.default)
					} else {
						return self_.getStylesVal(actionButton_.color)
					}
				}
			},
			$_inpStpLyt_styleInnerStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_inpStpLyt_styleInnerStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_inpStpLyt_styleInnerStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_inpStpLyt_styleInnerStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_inpStpLyt_styleInnerStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_inpStpLyt_styleInnerStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_inpStpLyt_styleInnerStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_inpStpLyt_styleInnerStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_inpStpLyt_styleInnerStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleInnerStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_inpStpLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_inpStpLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_inpStpLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_inpStpLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_inpStpLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_inpStpLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_inpStpLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_inpStpLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_inpStpLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_inpStpLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_inpStpLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_inpStpLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_inpStpLyt_styleQuestionActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'questionActionButton')
			},
			$_inpStpLyt_styleQuestionActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_inpStpLyt_styleQuestionActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_inpStpLyt_styleQuestionActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_inpStpLyt_styleQuestionActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_inpStpLyt_styleQuestionActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_inpStpLyt_styleQuestionActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_inpStpLyt_styleQuestionActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_inpStpLyt_styleQuestionActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_inpStpLyt_styleQuestionActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_inpStpLyt_styleQuestionActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_inpStpLyt_styleQuestionActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_inpStpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_inpStpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_inpStpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_inpStpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			// (content - question)
			$_inpStpLyt_styleContentQuestionImage() {
				return questionVals => {
					return questionVals.image
				}
			},
			$_inpStpLyt_styleContentQuestionImageUrl() {
				const self_ = this;
				return questionVals => {
					const image_ = self_.$_inpStpLyt_styleContentQuestionImage(questionVals)
					if(self_.isFalse(image_)) { return null }
					return self_.getStylesVal(image_)
				}
			}
		},
		created() {
			const self_ = this;
			// set input
			self_.$_inpStpLyt_setInputState()
			// first step
			const first_ = self_.$_inpStpLyt_setFirstStep()
			if(!self_.isFalse(first_)) { self_.innerStepNumber_ = first_ }
		},
		methods: {
			$_inpStpLyt_setInputState() {
				const self_ = this;
				// reset
				self_.setInputState('data', {})
				self_.setInputState('recruiting', {})
				self_.setInputState('sales', {})
				self_.setInputState('training', {})
				// set
				self_.setInputState('pageName', self_.$_inpLyt_statePageName)
				self_.setInputState('pageType', self_.$_inpLyt_statePageType)

				let questions_ = {}
				let data_ = {}

				Object.keys(self_.contents).forEach(contentKey => {
					if(!self_.isFalse(self_.contents[contentKey].questions)) {
						questions_ = self_.contents[contentKey].questions

						Object.keys(questions_).forEach(questionKey => {
							data_[questionKey] = {}

							data_[questionKey].order = questions_[questionKey].order;

							// question
							data_[questionKey].question = {}

							// question title & text
							let title_;
							if(self_.isFalse(questions_[questionKey].title)) { title_ = null }
							else { title_ = questions_[questionKey].title }

							data_[questionKey].question.title = title_;
							data_[questionKey].question.text = questions_[questionKey].text;

							// type
							Object.keys(questions_[questionKey].type).forEach(typeKey => {
								if(questions_[questionKey].type[typeKey]) { data_[questionKey].type = typeKey }
							})

							// answer
							if(		questions_[questionKey].type.combobox || 
									questions_[questionKey].type.select || 
									questions_[questionKey].type.textarea || 
									questions_[questionKey].type.textField ) { 
								data_[questionKey].answer = '';
							} else if(	questions_[questionKey].type.slider ) { 
								data_[questionKey].answer = 0
							} else if(	questions_[questionKey].type.comboboxMultiple || 
										questions_[questionKey].type.selectMultiple ) { 
								data_[questionKey].answer = [] 
							} else if(	questions_[questionKey].type.checkbox || 
										questions_[questionKey].type.switch ) { 
								data_[questionKey].answer = {}

								const options_ = questions_[questionKey].options

								Object.keys(options_).forEach(optionKey => {
									data_[questionKey].answer[optionKey] = {
										value: false,
										text: options_[optionKey].text
									}
								})
							} else { 
								data_[questionKey].answer = {}
							}
						})
					}
				})

				self_.setInputState('data', data_)

				return
			},
			$_inpStpLyt_setFirstStep() {
				const self_ = this;

				if(self_.isFalse(self_.contents)) { return null }

				let step_;

				Object.keys(self_.contents).forEach(key => {
					if(!step_) { step_ = self_.contents[key].stepNumber }

					if(self_.contents[key].isFirstStep) { step_ = self_.contents[key].stepNumber }
				})

				return step_
			},
			$_inpStpLyt_isPreSetButton(actionButtonKey) {
				const result_ = actionButtonKey == 'back' || 
								actionButtonKey == 'next' || 
								actionButtonKey == 'submit';
				return result_
			},
			$_inpStpLyt_click(contentVals, contentKey, actionType){
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					if(actionType == 'next') { return self_.$_inpStpLyt_nextStep(contentVals, contentKey) }
					if(actionType == 'back') { return self_.$_inpStpLyt_backStep(contentVals) }
					if(actionType == 'submit') { return self_.$_inpStpLyt_submit(contentVals, contentKey) }
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_inpStpLyt_top')
				}).catch(error => {
					self_.errorMessage_ = error;
					vuetify_.goTo('#_inpStpLyt_top')
				})
			},
			$_inpStpLyt_nextStep(contentVals, contentKey) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						self_.innerCompleted_[contentVals.stepNumber] = true;
						self_.innerStepNumber_ = contentVals.nextStepNumber;
						resolve()
					}).catch(() => {
						reject('Validation failed.')
					})
				})
			},
			$_inpStpLyt_backStep(contentVals) {
				const self_ = this;

				return new Promise(resolve => {
					self_.innerCompleted_[contentVals.previousStepNumber] = false;
					self_.innerStepNumber_ = contentVals.previousStepNumber;
					resolve()
				})
			},
			$_inpStpLyt_submit() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.mode_ = { 
					input: false,
					submit: true,
					finish: false
				}

				self_.outerStepNumber_++;

				self_.outerCompleted_ = { 
					input: true,
					submit: false,
					finish: false
				}

				vuetify_.goTo('#_inpStpLyt_top')
			},
			$_inpStpLyt_back() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.mode_ = { 
					input: true,
					submit: false,
					finish: false
				}

				self_.outerStepNumber_--;
				
				self_.outerCompleted_ = { 
					input: false,
					submit: false,
					finish: false
				}

				vuetify_.goTo('#_inpStpLyt_top')
			},
			$_inpStpLyt_confirm() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				if(self_.onProgress_) { return }

				self_.onProgress_ = true;

				Promise.resolve().then(() => {
					return self_.storeInput()
				}).then(() => {
					self_.mode_ = { 
						input: false,
						submit: false,
						finish: true
					}

					self_.outerStepNumber_++;

					self_.outerCompleted_ = { 
						input: true,
						submit: true,
						finish: false
					}

					self_.onProgress_ = false;

					vuetify_.goTo('#_inpStpLyt_top')
				}).catch(error => {
					self_.errorMessage_ = error;

					vuetify_.goTo('#_inpStpLyt_top')
					
/* error */			self_.logError('Error', '$_inpStpLyt_confirm()', error)
				})
			}
		}
	}
</script>

<style scoped>
	.stepper_ {
		box-shadow: none !important;
		background-color: transparent !important;
	}
	.stepperHeader_ {
		background-color: transparent !important;
		box-shadow: none !important;
		height: 80px !important;
	}
	.stepperItem_ {
		background-color: transparent !important;
		box-shadow: none !important;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>
